/**
 * Converts a string to lowercase
 *
 * @param value
 * @returns {string}
 */
export const lowercase = value => (value || value === 0) ? String(value).toLowerCase() : ''
